import { observable, observer, pr, React, theme } from "aaa";

@observer
export class GeorgeRadioButton extends React.Component<{
    defaultChecked: boolean;
    labelYes: string;
    labelNo: string;
    onCheck: (event: any, checked: boolean) => void;
    radioButtonStyle?: React.CSSProperties;
}> {
    @observable value = "yes";
    @observable focus = false;

    constructor(props: any) {
        super(props);
        this.value = this.props.defaultChecked ? "yes" : "no";
        this.state = {
            focus: false
        };
    }

    onChange = (event: any) => {
        this.value = event.target.value;
        this.props.onCheck(event, this.value === "yes");
    }

    renderSelected() {
        return (
            <>
                <span
                    className="theme-radio-inner-color"
                    style={{
                        height: 20,
                        width: 20,
                        borderRadius: "50%",
                        borderStyle: "solid",
                        borderWidth: 4,
                        position: "absolute",
                        left: 0,
                        boxSizing: "border-box"
                    }}
                />
                <span
                    className="theme-radio-color selected"
                    style={{
                        height: 20,
                        width: 20,
                        borderRadius: "50%",
                        border: "2px solid",
                        position: "absolute",
                        left: 0,
                        boxSizing: "border-box"
                    }}
                />
            </>
        );
    }

    renderDeselected() {
        return (
            <span
                className="theme-radio-color"
                style={{
                    height: 20,
                    width: 20,
                    borderRadius: "50%",
                    border: "2px solid",
                    position: "absolute",
                    left: 0,
                    boxSizing: "border-box"
                }}
            />
        );
    }

    renderOption(value: string, label: string) {
        const checked = {
            checked: this.value === value
        };

        return (
            <div
                className="theme-paragraph-color"
                style={{ fontSize: 14, margin: theme.MARGIN, ...this.props.radioButtonStyle }}
            >
                <label style={{ position: "relative", paddingLeft: 24, cursor: "pointer" }}>
                    <input
                        type="radio"
                        id={value}
                        name="checked"
                        value={value}
                        onChange={this.onChange}
                        style={{
                            opacity: 0
                        }}
                        onFocus={() => this.focus = true}
                        onBlur={() => this.focus = false}
                        {...checked}
                    />
                    {this.value === value && this.renderSelected()}
                    {this.value !== value && this.renderDeselected()}
                    {label}
                </label>
            </div>
        );
    }

    render() {
        return (
            <>
                {this.renderOption("yes", this.props.labelYes)}
                {this.renderOption("no", this.props.labelNo)}
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/GeorgeRadioButton.tsx